
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { AudioDevice, AudioTypes } from "@/types/audio/audio";

@Component({})
export default class AudioList extends Vue {
    @Prop({default:"Devices"})
    private listTitle: string

    @Prop({default: []})
    private audioDevices!: AudioDevice[];

    @Prop({default: null})
    private selectedAudioDevice: AudioDevice | null;

    private open: boolean = false;
    private audioOptionTypes: any = AudioTypes;

	private get filteredAudioDevices(): AudioDevice[] {
        return this.audioDevices.filter(audio =>
            audio.canReceive || audio.canTransmit || audio.canTwoway
        );
    }

	public collapseAudioList(): void {
        this.open = false;
    }

    @Emit("set-selected-device")
    private setSelectedAudioDevice(audioDevice: AudioDevice | null): AudioDevice | null {
        return audioDevice;
    }
}
